import React from 'react';
import { LegalDocument } from '../components/legal/LegalDocument';

export const AcceptableUsePolicyPage: React.FC = () => {
  return (
    <LegalDocument
      documentPath="/legal/acceptable-use-policy.md"
      title="Acceptable Use Policy"
      description="The rules governing how you may use admeru's platform and services. All users must comply with this policy."
    />
  );
};
